import { render, staticRenderFns } from "./Techniques.vue?vue&type=template&id=73731e0c&scoped=true"
import script from "./Techniques.vue?vue&type=script&lang=js"
export * from "./Techniques.vue?vue&type=script&lang=js"
import style0 from "./Techniques.vue?vue&type=style&index=0&id=73731e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73731e0c",
  null
  
)

export default component.exports